import {
  createGlobalConfig,
  panoramaClientFactory,
  PanoramaPlatform,
  PanoramaClient,
} from '@wix/panorama-client-web';

// Shared with the testkit; client creation stays browser-only because components also render on the server.
export const globalConfig = createGlobalConfig();
let panoramaClient: PanoramaClient | undefined;

export const flushPanorama = () => {
  try {
    // The reference apps use this optional queue API to retain reports across navigation.
    (
      globalConfig.getBatchQueue() as unknown as
        | { flush?: () => void }
        | undefined
    )?.flush?.();
  } catch (_) {
    // Monitoring must not interrupt navigation if the upstream queue API changes.
  }
};

export const getPanoramaClient = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  if (panoramaClient) {
    return panoramaClient;
  }
  const config = window.__MONITORING_CONFIG__;
  const userId = config?.authenticated ? config.userId : undefined;
  const sentry = window.Sentry;
  panoramaClient = panoramaClientFactory({
    baseParams: {
      platform: PanoramaPlatform.Standalone,
      fullArtifactId: 'com.wixpress.studio-templates',
      artifactVersion: config?.artifactVersion,
      componentId: 'studio-templates',
      uuid: userId,
    },

    pluginParams: {
      sentry,
      sentryDsn: config?.sentryDsn,
      sentryMain: true,
      sentryEnvironment: config?.environment,
    },
  })
    .withGlobalConfig(globalConfig)
    .client();

  // InboundFilters reads these options on each event, including Panorama's Sentry hub.
  const options = sentry?.getCurrentHub().getClient()?.getOptions() as
    | {
        ignoreErrors?: string[];
        denyUrls?: RegExp[];
        allowUrls?: string[];
        release?: string;
      }
    | undefined;
  if (options) {
    options.release = config?.release;
  }
  sentry?.configureScope((scope) => {
    scope.setUser({ id: config?.userId, clientId: config?.clientId });
    scope.setExtra('user.authenticated', config?.authenticated);
    scope.setExtra('sessionId', config?.sessionId);
  });

  window.addEventListener('pagehide', flushPanorama);
  return panoramaClient;
};
